export const getYoutubeVideo = (url, clean = false) => {
	let cleanString = clean ? "&controls=0&mute=1&modestbranding=1" : "";
	return `//www.youtube.com/embed/${getYoutubeId(url)}?&rel=0&autoplay=1${cleanString}`;
};
let getYoutubeId = (url) => {
	let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	let match = url.match(regExp);

	if (match && match[2].length == 11) {
		return match[2];
	} else {
		return "";
	}
};
export const getVimeoVideo = (url) => {
	return `https://player.vimeo.com/video/${getVimeoId(url)}?showinfo=0&rel=0&autoplay=1`;
};

let getVimeoId = (url) => {
	var re = /\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i;
	var matches = re.exec(url);
	return matches && matches[1];
};
